import { createFileRoute, type ErrorComponentProps } from "@tanstack/react-router";
import { CmsRouteView } from "@/components/cms/CmsRouteView";
import { publishedCmsPageQuery } from "@/lib/cms/queries";
import { canonicalUrl } from "@/lib/seo/site";

export const Route = createFileRoute("/terms")({
  head: () => ({ meta: [
    { title: "Terms & Conditions — CB16 Atelier" },
    { name: "description", content: "The terms of sale and site use for CB16 Atelier." },
    { property: "og:title", content: "CB16 Terms & Conditions" },
    { property: "og:description", content: "The terms of sale and site use for CB16 Atelier." },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary" },
    { property: "og:url", content: canonicalUrl("/terms") },
  ], links: [{ rel: "canonical", href: canonicalUrl("/terms") }] }),
  loader: ({ context }) => context.queryClient.ensureQueryData(publishedCmsPageQuery("terms")),
  errorComponent: ({ error }: ErrorComponentProps) => (
    <div role="alert" className="mx-auto max-w-3xl px-6 py-24 text-center text-sm text-black/60">
      {error instanceof Error ? error.message : "Something went wrong."}
    </div>
  ),
  notFoundComponent: () => (
    <div className="mx-auto max-w-3xl px-6 py-24 text-center text-sm text-black/60">Page not found.</div>
  ),
  component: () => <CmsRouteView slug="terms" fallbackTitle="Terms & Conditions" />,
});